import type { FC } from 'react'
import { useRef } from 'react'
import { FieldInputProps, useField } from 'formik'
import { RadioGroup, RadioGroupProps } from '@mui/material'
import { useFocusOnFirstError } from '@dhl/use-focus-on-first-error'

type Props = Omit<RadioGroupProps, keyof FieldInputProps<string>> & {
  name: string
}

export const RadioGroupInput: FC<Props> = ({ name, ...props }) => {
  const [field] = useField<string>(name)
  const inputRef = useRef<HTMLInputElement>(null)
  useFocusOnFirstError(field.name, inputRef, inputRef)

  return <RadioGroup {...props} name={name} onChange={field.onChange} value={field.value} ref={inputRef} />
}
